var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$apollo.queries.eventFinancialReport.loading)?_c('AppLoadingPage'):_c('PersonStatementReportTemplate',{attrs:{"event-financial-report":_vm.eventFinancialReport,"event":_vm.event}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }